export const isNumberInputKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
	const key = e.key;
	if ((e.ctrlKey || e.metaKey) && e.keyCode === 67) {
		// Do stuff.
		return true;
	}

	// Ctrl+V or Cmd+V pressed?
	if ((e.ctrlKey || e.metaKey) && e.keyCode === 86) {
		// Do stuff.
		return true;
	}

	// Ctrl+X or Cmd+X pressed?
	if ((e.ctrlKey || e.metaKey) && e.keyCode === 88) {
		// Do stuff.
		return true;
	}
	if (
		!/[0-9]/.test(key) &&
		key !== 'Backspace' &&
		key !== 'Delete' &&
		key !== 'ArrowLeft' &&
		key !== 'ArrowRight'
	) {
		e.preventDefault();
		return false;
	}
};
